import PrimaryCell from "../../../../ui/Table/Cells/PrimaryCell";

export const columns = [
  {
    dataField: "sessionDate",
    caption: "Дата прохождения",
    dataType: "date",
    cellRender: PrimaryCell,
    width: 100
  },
  {
    dataField: "quizName",
    caption: "Опрос",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "personName",
    caption: "Пользователь",
    dataType: "string",
    cellRender: PrimaryCell
  },
];
